/**
 * KAN-851: чистые функции карточки организации в приложении менеджера:
 * ссылка на сайт, строка "город, регион".
 */
import type { ClientCompany } from '@/types/clientCompany';

/** Ссылка на сайт: без схемы дописываем https://; пусто, если сайта нет. */
export function websiteHref(website: string | null | undefined): string {
  const value = (website ?? '').trim();
  if (!value) return '';
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
}

/** "Город, регион" (что известно; регион не повторяет город). */
export function companyLocation(company: Pick<ClientCompany, 'city' | 'region'>): string {
  const city = (company.city ?? '').trim();
  const region = (company.region ?? '').trim();
  return [city, region !== city ? region : ''].filter(Boolean).join(', ');
}

/** Непустые строки списка (телефоны, почты) без пробелов по краям. */
export function nonEmpty(values: readonly string[] | null | undefined): string[] {
  return (values ?? []).map((value) => value.trim()).filter(Boolean);
}
